import React, { useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Box, Card, CardContent, CardHeader, Divider, Link, Button, Tooltip, Typography, IconButton, } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";

import Cookies from "js-cookie";
import axios from "axios";
import styles, { boxSX } from "./Styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Download } from "@mui/icons-material";
import Loader from "../../CommonComponents/Loader";
import { SSPCommonButton } from "../../CommonComponents";
import { post } from "../../services";
import SSPCommonModal from "../../CommonComponents/SSPCommonModal/SSPCommonModal";

const base = "https://";

const TruIDMaster = ({ token }) => {

    const id = Cookies.get("ssp_id");
    const domain_id = Cookies.get("ssp_domain_id");
    const [loading, setLoading] = useState(false);
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [row, setRows] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        rowFetch();
    }, []);

    const rowFetch = async () => {
        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/trueid_mdm/get_uploaded_filesdata",
            {},
            true,
            false
        );
        if (response?.statusCode === 200 || response?.body?.status === "success") {
            const rowsData = response?.body?.data?.map((row, index) => ({
                ...row,
                id: index + 1,
            }));
            setRows(rowsData);

        } else {
            setmessage("No Rows");
            setmodalOpener(true);
        }
    };

    const downloadProcessLog = async (logId) => {
        setLoading(true)

        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/trueid_mdm/download_data",
            {
                "type": "PROCESS_LOG",
                "log_id": Number(logId),
            },
            true,
            false
        );
        if (response?.statusCode === 200 || response?.body?.status === "success") {
            setLoading(false)
            window.open(response?.body?.data_url || response?.data_url);

        } else {
            setLoading(false)
            setmessage(response?.body?.message || response?.message);
            setmodalOpener(true);
        }
    }

    const handleUpload = async () => {
        if (selectedFile) {
            if (selectedFile instanceof File) {
                const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
                if (fileExtension !== "xlsx") {
                    setmessage("Only .xlsx files are allowed.");
                    setmodalOpener(true);
                    return;
                }
            }
            setLoading(true)
            let filenameWithTimestamp;
            if (selectedFile instanceof File) {
                const timestamp = new Date()
                    .toISOString()
                    .replace(/[-:.]/g, "")
                    .slice(0, 15);
                filenameWithTimestamp = `${selectedFile?.name
                    .split(".")
                    .slice(0, -1)
                    .join(".")}_${timestamp}.${selectedFile?.name?.split(".")?.pop()}`;
            } else {
                filenameWithTimestamp = selectedFile;
            }
            let presignedUrlResponse = await post(
                base +
                "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/trueid_mdm/gen_post_url",
                {
                    file_name: filenameWithTimestamp?.replace(/[()]/g, ""),
                },
                true,
                false
            );
            if (presignedUrlResponse?.status === 'error') {
                setmessage(presignedUrlResponse?.data?.message);
                setmodalOpener(true);
                return
            }

            const presignedUrl = presignedUrlResponse.body.response;

            if (!presignedUrl) {
                console.error("Presigned URL is not valid");
                return;
            }
            if (selectedFile instanceof File) {
                const fileUploaded = await uploadFileWithPresignedUrl(
                    selectedFile,
                    presignedUrl
                );
                if (fileUploaded) {
                    let response = await post(
                        base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/trueid_mdm/save_ip_details",
                        {
                            file_name: presignedUrl.fields.key,
                        },
                        true,
                        false
                    );
                    if (response?.statusCode === 200 || response?.body?.status === "success") {
                        setLoading(false)
                        setmessage(response?.message || "File Uploaded");
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);
                        setTimeout(() => {
                            window.location.reload();
                        }, 2000);

                    } else if (response?.status === "Error" || response?.body?.status === "error") {
                        setLoading(false)
                        setmessage(response?.message || response?.body?.message);
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);
                    }
                    else {
                        setLoading(false)
                        setmessage(response?.body?.message);
                        setmodalOpener(true);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        setSelectedFile(null);

                    }

                }

                if (!fileUploaded) {
                    if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                    }
                    setLoading(false)
                    setSelectedFile(null);

                    console.error("File upload failed");
                    return;
                }
            }

        } else {
            setLoading(false)
            setmessage("Please select file to upload");
            setmodalOpener(true);
        }
    }
    const uploadFileWithPresignedUrl = async (filetoUpload, generatedUrl) => {
        try {
            const fileUploadData = new FormData();
            Object.keys(generatedUrl.fields).forEach((key) => {
                fileUploadData.append(key, generatedUrl.fields[key]);
            });
            fileUploadData.append("file", filetoUpload);
            const fileUploaded = await uploadFile(generatedUrl.url, fileUploadData);
            if (fileUploaded) {
                return true;
            } else {
                console.error("File upload failed");
                return false;
            }
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };

    const uploadFile = async (url, formData) => {
        try {
            const response = await axios.post(url, formData);
            if (response.status === 204) {
                console.log("File upload successful with status 204");
                return true;
            }
            if (response.status >= 200 && response.status < 300) {
                console.log("File upload successful");
                return true;
            } else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };

    const handleDownloadSampleFile = async () => {
        setLoading(true)
        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/trueid_mdm/download_data",
            {
                "type": "SAMP",
            },
            true,
            false
        );
        if (response?.statusCode === 200 || response?.body?.status === "success") {
            setLoading(false)
            window.open(response?.body?.data_url);
        } else {
            setLoading(false)
            setmessage(response?.message || response?.body?.message);
            setmodalOpener(true);
        }

    };

    const handleDownloadMasterData = async () => {
        setLoading(true)
        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/trueid_mdm/download_data",
            {
                "type": "IP",
            },
            true,
            false
        );
        if (response?.statusCode === 200 || response?.body?.status === "success") {
            setLoading(false)
            window.open(response?.body?.data_url);
        } else {
            setLoading(false)
            setmessage(response?.message || response?.body?.message);
            setmodalOpener(true);
        }
    }
    const ReasonCell = ({ value }) => {
        return (
            <Tooltip
                title={
                    <span style={{ fontSize: "16px", }}>{value}</span>
                }
            >
                <div
                    style={{
                        whiteSpace: "none",
                        textAlign: "center",
                        maxWidth: "100%",

                    }}
                >{value}</div>
            </Tooltip>
        );
    };

    const columns = [
        {
            field: 'sr_no',
            headerName: 'Sr no',
            headerAlign: 'center',
            align: 'center',
            width: isMobile ? 150 : 110,
            renderCell: (params) => (
                <div>
                    {params.id}
                </div>
            )
        },
        {
            field: 'log_id',
            headerName: 'Log id',
            headerAlign: 'center',
            align: 'center',
            width: isMobile ? 150 : 110,
            renderCell: (params) => (
                <div>
                    {params.value}
                </div>
            )
        },
        {
            field: "file_name",
            headerName: " File Name",
            headerAlign: "center",
            align: "center",
            width: 210,
            renderCell: (params) => <ReasonCell value={params.value ? params.value : "--"} />,
        },
        {
            field: 'created_at',
            headerName: 'Date',
            headerAlign: 'center',
            align: 'center',
            width: isMobile ? 180 : 150,
            renderCell: (params) => <ReasonCell value={params.value ? params.value : "--"} />,
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{
                    textAlign: 'center', color: params.value === 'Success' ? 'green' : 'red',
                }}>{params.value}</div>
            ),
        },

        {
            field: 'records_processed',
            headerName: (
                <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                    No of records processed
                </div>
            ),
            width: isMobile ? 180 : 200,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <div style={{ textAlign: 'center' }}>{params?.value ? params?.value : '0'}</div>
            ),
        },
        {
            field: "current_status",
            headerName: "Progress",
            headerAlign: "center",
            align: "center",
            width: isMobile ? 170 : 200,
            renderCell: (params) => {
                return (
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        width="100%"
                        height="100%"
                        textAlign="center"
                        style={{
                            lineHeight: 1.5,
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: "0.9rem",
                                marginBottom: "4px",
                                color: params.value === 'Partial File Uploaded ' ? 'red' : params.value === 'File Uploaded' && 'green'
                            }}
                        >
                            {params.value}
                        </Typography>

                    </Box>
                );
            },
        },
        {
            field: "process_log",
            headerName: "Process Log",
            headerAlign: "center",
            width: 155,
            align: "center",

            renderCell: (params) => (
                <IconButton
                    aria-label="Download Process Log"
                    onClick={() => downloadProcessLog(params.row.log_id)}
                >
                    <Download color="primary" />
                </IconButton>
            ),
        },

    ];
    return (
        <Box>
            <Loader loading={loading} />
            <Card sx={styles.assetmasterCard} >
                <CardHeader
                    p={2}
                    sx={styles.cardHeader}
                    title={" Upload excel"}
                    titleTypographyProps={{
                        sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                    }}
                />
                <Divider />
                <CardContent sx={styles.assetmasterCardContent} >
                    <Grid container spacing={2} >
                        <Grid item xs={12} sm={6} md={6} lg={4} xl={4} sx={styles.locContainer} >
                            <Box p={2} sx={styles.fileStyle} >
                                <Box p={1} sx={styles.fileInputStyle} >
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        multiple={false}
                                        onChange={(e) => {
                                            setSelectedFile(e.target.files[0]);
                                        }}

                                    />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3.5} xl={4} sx={{ ...styles.dwnldAssetMasterbttnStyle, marginLeft: isMobile ? 3 : 0 }} >
                            <SSPCommonButton
                                btnText="Save data"
                                btnFunction={() => {
                                    handleUpload()
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Box p={1} sx={styles.buttonBox} >
                        <Link
                            component={"button"}
                            color={"#0160F1"}
                            sx={boxSX}
                            onClick={handleDownloadSampleFile}
                        >
                            {"Download Sample File"}
                        </Link>
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={styles.deviderStyle}
                        />
                        <Link
                            component={"button"}
                            color={"#0160F1"}
                            sx={boxSX}
                            onClick={handleDownloadMasterData}
                        >
                            {"Download Master Data"}
                        </Link>
                    </Box>
                </CardContent>
                <Card sx={styles.card} >
                    <CardHeader
                        p={2}
                        sx={styles.cardHeader}
                        title={"Uploaded Files"}
                        titleTypographyProps={{
                            sx: { fontSize: "16px", fontWeight: "600", lineHeight: "16px", color: "#0160F1", },
                        }}
                        action={
                            <>
                                <Button onClick={() => window.location.reload()}>
                                    Refresh Page
                                </Button>
                            </>
                        }
                    />
                    <Divider />
                    <CardContent sx={styles.assetmasterCardContent} >
                        <Box
                            sx={{
                                backgroundColor: "#FFFFFF",
                                borderBottomRightRadius: "5px",
                                borderBottomLeftRadius: "5px",
                                padding: isMobile ? "8px" : "16px",
                                height: 700,
                            }}
                        >
                            <DataGrid
                                rowHeight={80}
                                showCellRightBorder={true}

                                sx={{
                                    ".MuiDataGrid-columnHeaderTitle": {
                                        fontWeight: "bold !important",
                                        fontSize: isMobile ? "0.7rem" : "0.875rem",
                                    },
                                    ".MuiDataGrid-cell": {
                                        fontSize: isMobile ? "0.6rem" : "0.8rem",
                                        padding: isMobile ? "4px" : "8px",
                                    },
                                    ".MuiDataGrid-root": {
                                        minWidth: isMobile ? "50%" : "auto",
                                    },
                                    overflowX: "auto",

                                }}
                                rows={row}
                                columns={columns}

                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                headerClassName="header-center"
                                rowsPerPageOptions={[10]}
                                pageSize={10}
                                getRowId={(row) => row.id}
                                components={{
                                    Toolbar: GridToolbar,
                                }}
                                componentsProps={{
                                    Toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                            />
                        </Box>
                        {modalOpener && (
                            <SSPCommonModal
                                open={modalOpener}
                                handleOpenClose={setmodalOpener}
                                message={message}
                            />
                        )}
                    </CardContent>
                </Card>
            </Card>
            {modalOpener && (
                <SSPCommonModal
                    open={modalOpener}
                    handleOpenClose={setmodalOpener}
                    message={message}
                />
            )}
        </Box>
    )
}

export default TruIDMaster


